import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import { Button, FormGroup, Label } from "reactstrap";
import { __t } from "../../../../i18n/translator";
import {
  VENDOR_USER_ROLES,
  vendorRoleOptionsFromIds,
} from "../../../../constant/commonConstants";
import {
  addVendorUserRequest,
  assignVendorUserRequest,
  getUnassignedVendorUserListRequest,
} from "../../../../redux/admin/vendorUser/action";

export const addVendorUserInitialState = (values) => {
  let value = values === undefined || values === null ? "" : values;

  return {
    vendorUserId: value?.vendorUserId,
    contactName: value?.contactName || "",
    email: value?.userEmail || "",
    phoneNumber: value?.phoneNumber || "",
    roles: vendorRoleOptionsFromIds(value?.roleID),
  };
};

const NewUserIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M19 8v6M22 11h-6" />
  </svg>
);

const ExistingUserIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="m16 11 2 2 4-4" />
  </svg>
);

function AddVendorUser(props) {
  const {
    onModalDismiss,
    dispatchData,
    AddVendorUserStatus,
    AddVendorUserRequest,
    AssignVendorUserRequest,
    GetUnassignedVendorUserList,
    unassignedVendorUsers,
    setIsEdit,
    onModeChange,
  } = props;
  const IsEditData = props?.data?.vendorUserId;
  const [closeModal, setCloseModal] = useState(false);
  const validator = useRef(new SimpleReactValidator());
  const [vendorUserData] = useState(addVendorUserInitialState(props?.data));
  const [mode, setMode] = useState(IsEditData ? "new" : null);
  const isExisting = mode === "existing";
  const [existingUser, setExistingUser] = useState(null);
  const [existingRoles, setExistingRoles] = useState([]);
  const [rolesMenuOpen, setRolesMenuOpen] = useState(false);
  const assignValidator = useRef(new SimpleReactValidator());

  useEffect(() => {
    if (!IsEditData) {
      GetUnassignedVendorUserList({ vendorId: dispatchData?.vendorId });
    }
  }, []);

  useEffect(() => {
    if (onModeChange) {
      onModeChange(mode);
    }
  }, [mode]);

  const existingUserOptions = (unassignedVendorUsers || []).map((user) => ({
    value: user.vendorUserId,
    label: `${user.contactName} (${user.userEmail})`,
  }));

  const handleAssign = () => {
    if (assignValidator.current.allValid()) {
      AssignVendorUserRequest({
        values: {
          vendorId: dispatchData?.vendorId,
          vendorUserId: existingUser?.value,
          roleId: existingRoles?.map((role) => role.value).join(","),
        },
        dispatchData,
      });
      setCloseModal(true);
    } else {
      assignValidator.current.showMessages();
      setExistingRoles((roles) => [...roles]);
    }
  };

  const handleSubmit = async (values) => {
    if (validator.current.allValid()) {
      AddVendorUserRequest({
        values: {
          vendorId: dispatchData?.vendorId,
          vendorUserId: values.vendorUserId,
          contactName: values.contactName,
          email: values.email,
          phoneNumber: values.phoneNumber,
          roleId: values.roles?.map((role) => role.value).join(","),
          createdBy: localStorage.getItem("user"),
        },
        dispatchData,
      });
      setCloseModal(true);
    } else {
      validator.current.showMessages();
    }
  };

  useEffect(() => {
    if (closeModal === true) {
      onModalDismiss(false);
      setIsEdit(null);
      setCloseModal(false);
    }
  }, [AddVendorUserStatus === true]);

  if (mode === null) {
    return (
      <div className="choice-modal">

        <button
          type="button"
          className="choice-card"
          onClick={() => setMode("new")}
        >
          <span className="choice-card-icon is_new">
            <NewUserIcon />
          </span>
          <span className="choice-card-text">
            <span className="choice-card-title">Create New Vendor User</span>
            <span className="choice-card-note">
              Make a new login and email them a password to set.
            </span>
          </span>
        </button>

        <button
          type="button"
          className="choice-card"
          onClick={() => setMode("existing")}
        >
          <span className="choice-card-icon is_existing">
            <ExistingUserIcon />
          </span>
          <span className="choice-card-text">
            <span className="choice-card-title">Add Existing Vendor User</span>
            <span className="choice-card-note">
              Give someone who already works for another vendor access here.
            </span>
          </span>
        </button>
      </div>
    );
  }

  if (isExisting) {
    return (
      <>
        <div className="form-horizontal form-login">
          <div className="category-head">
            <FormGroup className="mb-3">
              <Select
                className="form-control selectbox"
                menuPlacement="auto"
                placeholder="Select..."
                options={existingUserOptions}
                value={existingUser}
                onChange={(data) => setExistingUser(data)}
                noOptionsMessage={() => "Every user is already in this vendor"}
              />
              <Label className="form-label">
                Vendor User
                <span className="text-danger required">*</span>
              </Label>
              {assignValidator.current.message(
                "user",
                existingUser?.value || "",
                "required",
                { messages: { required: "Please select a user." } }
              )}
            </FormGroup>

            <FormGroup className="mb-3">
              <Select
                className="form-control selectbox roles_select"
                isMulti
                closeMenuOnSelect={false}
                menuPlacement="auto"
                options={VENDOR_USER_ROLES}
                value={existingRoles}
                menuIsOpen={rolesMenuOpen}
                onMenuOpen={() => setRolesMenuOpen(true)}
                onMenuClose={() => setRolesMenuOpen(false)}
                onChange={(data) => {
                  const picked = data || [];
                  setExistingRoles(picked);
                  if (picked.length === VENDOR_USER_ROLES.length) {
                    setRolesMenuOpen(false);
                  }
                }}
              />
              <Label className="form-label">
                Roles
                <span className="text-danger required">*</span>
              </Label>
              {assignValidator.current.message(
                __t("validations.vendorUser.roles"),
                existingRoles?.length ? existingRoles.length : "",
                "required",
                { messages: { required: __t("validations.vendorUser.roles") } }
              )}
            </FormGroup>
          </div>

          <div className="btn-box with-back">
            <Button
              type="button"
                color="secondary"
              // className="choice-back"
              onClick={() => setMode(null)}
            >
              Back
            </Button>
            <Button color="primary" type="button" onClick={handleAssign}>
              Add To Vendor
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Formik initialValues={vendorUserData} onSubmit={handleSubmit}>
        {({ isSubmitting, values, setFieldValue }) => (
          <Form className="form-horizontal form-login">
            <div className="category-head">
              <FormGroup className="mb-3">
                <Field
                  type="text"
                  id="contactName"
                  name="contactName"
                  className="form-control"
                  placeholder="User Name"
                />
                <Label className="form-label" htmlFor="contactName">
                  Contact Name
                  <span className="text-danger required">*</span>
                </Label>
                {validator.current.message(
                  __t("validations.vendorUser.contactName"),
                  values.contactName,
                  "required",
                  {
                    messages: {
                      required: __t("validations.vendorUser.contactName"),
                    },
                  }
                )}
              </FormGroup>

              <FormGroup className="mb-3">
                <Field
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Email Address"
                />
                <Label className="form-label" htmlFor="email">
                  Email Address
                  <span className="text-danger required">*</span>
                </Label>
                {validator.current.message(
                  __t("validations.vendorUser.email"),
                  values.email,
                  "required|email",
                  {
                    messages: {
                      required: __t("validations.vendorUser.email"),
                    },
                  }
                )}
              </FormGroup>

              <FormGroup className="mb-3">
                <Field
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  className="form-control"
                  placeholder="Mobile No."
                  maxLength={10}
                  minLength={10}
                />
                <Label className="form-label" htmlFor="phoneNumber">
                  Mobile No.
                </Label>
                {validator.current.message(
                  "phoneNumber",
                  values.phoneNumber,
                  "matches:^[0-9]{10}$|numeric",
                  {
                    messages: {
                      matches: __t("validations.vendorUser.matches"),
                    },
                  }
                )}
              </FormGroup>

              <FormGroup className="mb-3">
                <Field
                  id="roles"
                  name="roles"
                  className="form-control selectbox roles_select"
                  component={Select}
                  isMulti
                  closeMenuOnSelect={false}
                  menuPlacement="auto"
                  options={VENDOR_USER_ROLES}
                  value={values.roles}
                  menuIsOpen={rolesMenuOpen}
                  onMenuOpen={() => setRolesMenuOpen(true)}
                  onMenuClose={() => setRolesMenuOpen(false)}
                  onChange={(data) => {
                    const picked = data || [];
                    setFieldValue("roles", picked);
                    if (picked.length === VENDOR_USER_ROLES.length) {
                      setRolesMenuOpen(false);
                    }
                  }}
                />
                <Label className="form-label" htmlFor="roles">
                  Roles
                  <span className="text-danger required">*</span>
                </Label>
                {validator.current.message(
                  __t("validations.vendorUser.roles"),
                  values.roles?.length ? values.roles.length : "",
                  "required",
                  {
                    messages: {
                      required: __t("validations.vendorUser.roles"),
                    },
                  }
                )}
              </FormGroup>
            </div>

            <div className={`btn-box${IsEditData ? "" : " with-back"}`}>
              {!IsEditData && (
                <Button
                color="secondary"
                  type="button"
                  // className="choice-back"
                  onClick={() => setMode(null)}
                >
                   Back
                </Button>
              )}
              <Button
                color="primary"
                title="vendor user data"
                type="submit"
                disabled={isSubmitting}
              >
                {IsEditData ? "Update" : "Submit"}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

const mapStateToProps = ({ adminVendorUser }) => {
  return {
    AddVendorUserStatus:
      adminVendorUser?.addVendorUser?.status &&
      adminVendorUser.addVendorUser.status,
    unassignedVendorUsers: adminVendorUser?.unassignedVendorUsers?.list || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddVendorUserRequest: (data) => dispatch(addVendorUserRequest(data)),
    AssignVendorUserRequest: (data) => dispatch(assignVendorUserRequest(data)),
    GetUnassignedVendorUserList: (data) =>
      dispatch(getUnassignedVendorUserListRequest(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddVendorUser);
